// local
// actions
import { pending, rejected, fulfilled } from './async';
import dispatchError from './error';
import { showSnackbar } from './snackbar';
// api
import Device from 'app/api/device';

export const list = () => dispatch => {
    dispatch(pending('DEVICE_LIST'));
    Device.list()
        .then(payload => dispatch(fulfilled('DEVICE_LIST', payload)))
        .catch(err => {
            dispatch(rejected('DEVICE_LIST', err));
            dispatchError(dispatch, err);
        });
};

export const create = data => dispatch => {
    dispatch(pending('SAVE_UPDATE_MODAL'));
    Device.create(data)
        .then(payload => {
            dispatch(fulfilled('SAVE_UPDATE_MODAL', payload));
            dispatch({ type: 'DEVICE_LIST_CREATE', payload });
            dispatch(showSnackbar({ title: `O dispositivo ${payload.key} foi adicionado com sucesso!`, action: true }));
        })
        .catch(err => {
            dispatch(rejected('SAVE_UPDATE_MODAL', err));
            dispatchError(dispatch, err, false);
        });
};

export const update = (id, data) => dispatch => {
    dispatch(pending('SAVE_UPDATE_MODAL'));
    Device.update(id, data)
        .then(payload => {
            dispatch(fulfilled('SAVE_UPDATE_MODAL', payload));
            dispatch({ type: 'DEVICE_LIST_UPDATE', payload });
            dispatch(showSnackbar({ title: 'As alterações realizadas foram salvas.', action: true }));
        })
        .catch(err => {
            dispatch(rejected('SAVE_UPDATE_MODAL', err));
            dispatchError(dispatch, err, false);
        });
};

export const search = term => ({
    type: 'DEVICE_LIST_SEARCH',
    payload: term,
});

export const reset = () => ({
    type: 'DEVICE_LIST_RESET',
});
